<template>
  <header class="header">
    <nav id="nav" class="navbar fixed-top navbar-expand-lg navbar-dark">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">{{ title }}</a>

        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarText"
          aria-controls="navbarText"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarText">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a class="nav-link"
                ><router-link to="/faqs">Preguntas frecuentes</router-link></a
              >
            </li>
            
            <li class="nav-item">
              <a class="nav-link"
                ><router-link to="/contact">Contacto</router-link></a
              >
            </li>

            <li v-if="userLogged" class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ userLogged }}
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <li class="nav-link">
                  <a class="dropdown-item"
                    ><router-link to="/datos">Datos</router-link></a
                  >
                </li>
                <li>
                  <a class="dropdown-item" @click="closeSession()"
                    >Cerrar sesión</a
                  >
                </li>
              </ul>
            </li>
            <!--<li class="nav-item">
            <a class="nav-link"><router-link to="/login">Inicio de sesión</router-link></a>
          </li>-->
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<style scoped>
.navbar {
  background-color: #f39ec5;
}

#nav a {
  color: white;
  text-decoration: none;
}

/* Add the below transitions to allow a smooth color change similar to lyft */
.navbar {
  -webkit-transition: all 0.6s ease-out;
  -moz-transition: all 0.6s ease-out;
  -o-transition: all 0.6s ease-out;
  -ms-transition: all 0.6s ease-out;
  transition: all 0.6s ease-out;
}

.navbar.scrolled {
  background: rgb(68, 68, 68); /* IE */
  background: rgba(
    243,
    158,
    197,
    0.88
  ); /* NON-IE */ /* Convert back-color to transparent */
}

.dropdown-menu {
  background-color: #f39ec5;
  border-radius: 8px;
}
</style>

<script>
import auth from "@/auth/auth";

export default {
  name: "NavigationBar",
  props: {
    title: String,
  },
  methods: {
    closeSession() {
      auth.deleteUserLogged();
      return this.$router.go("/");
    },
  },
  computed: {
    userLogged() {
      return auth.getUserEmailLogged();
    },
  },
};
</script>